import React from 'react';
import logoMark from '../../assets/Logov2.png';

const SIZES = {
  sm: 'h-10 w-10',
  md: 'h-16 w-16',
  lg: 'h-28 w-28',
};

// Circular-arrow mark + "LeaseCheck" wordmark (mockup Welcome/Payment Status).
// Note: assets/logov2.svg is a checkmark-in-circle, not the mockup's arrow mark;
// assets/Logov2.png is the matching glossy green arrow mark, used here instead.
export function Logo({ size = 'md', className = '' }) {
  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <img src={logoMark} alt="LeaseCheck logo" className={SIZES[size] || SIZES.md} />
      <span className="text-2xl font-bold text-black">LeaseCheck</span>
    </div>
  );
}
